import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";

const About = () => {
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");
  useEffect(() => {
    setPrevLocation(location.state.data);
  }, [location]);
  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="About" prevLocation={prevLocation} />
      <div className="pb-10">
        <h1 className="max-w-[600px] text-base text-lightText mb-2 text-justify">
          At
          <span className="text-primeColor font-semibold text-lg"> Heritage Harvest</span>{" "}
          , we bring the authentic taste of Kerala’s spice heritage straight to your kitchen. Nestled in the lush hills of Idukki, our farms produce premium-quality cardamom and black pepper, handpicked to ensure purity, freshness, and natural aroma.
          <p>
            Our journey began with these two prized spices, and we are committed to expanding our offerings to include a wide variety of authentic Indian spices. With a focus on quality, tradition, and trust, Heritage Harvest stands for delivering the finest flavors from nature — connecting you to the rich legacy of Kerala’s spice culture.
          </p>
        </h1>
        <Link to="/">
          <button className="w-52 h-10 bg-primeColor text-white hover:bg-black duration-300">
            Continue Shopping
          </button>
        </Link>
      </div>
    </div>
  );
};

export default About;
